const bisNotificationsActionTypes = {
  // fetch bis notifications
  FETCH_BIS_NOTIFICATIONS: "FETCH_BIS_NOTIFICATIONS",
  FETCH_BIS_NOTIFICATIONS_SUCCESS: "FETCH_BIS_NOTIFICATIONS_SUCCESS",
  FETCH_BIS_NOTIFICATIONS_FAILURE: "FETCH_BIS_NOTIFICATIONS_FAILURE",
  // export bis notifications csv
  EXPORT_BIS_CSV: "EXPORT_BIS_CSV",
  EXPORT_BIS_CSV_SUCCESS: "EXPORT_BIS_CSV_SUCCESS",
  EXPORT_BIS_CSV_FAILURE: "EXPORT_BIS_CSV_FAILURE",
};

export default bisNotificationsActionTypes;
